import React, { useState } from "react";
import Instructors from "../components/Users/Instructors";

function UsersLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <Instructors handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default UsersLayout;
